import styled, { css } from 'styled-components';
import { fontSize } from '../../../../mixins';
import { mobileResponsiveXs } from '../common.style';
var StyledH2 = styled.h2.withConfig({
  displayName: "H2style__StyledH2",
  componentId: "sc-yqmjhd-0"
})(["margin:0;outline:transparent;", ";", ";", ";", ";", ";", ";"], color, light, bold, impact, accent, size);

function color(_ref) {
  var theme = _ref.theme,
      isOnDarkBg = _ref.isOnDarkBg;
  var fontColor = isOnDarkBg ? theme.color.white : theme.color.black;
  return css(["color:", ";"], fontColor);
}

function light(_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return variant === 'light' && css(["font-weight:", ";font-family:", ";"], theme.font.weight.light, theme.font.family.primary);
}

function bold(_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return variant === 'bold' && css(["font-weight:", ";"], theme.font.weight.bold);
}

function impact(_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === 'impact' && css(["font-weight:", ";font-family:", ";text-transform:uppercase;line-height:", ";"], theme.font.weight.regular, theme.font.family.impact, theme.font.size.xlg);
}

function accent(_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme,
      isOnDarkBg = _ref5.isOnDarkBg;
  return variant === 'accent' && css(["font-weight:", ";font-family:", ";color:", ";"], theme.font.weight.regular, theme.font.family.accent, isOnDarkBg ? theme.color.white : theme.color.primary);
}

function size(_ref6) {
  var theme = _ref6.theme,
      shouldResize = _ref6.shouldResize;

  if (shouldResize) {
    return mobileResponsiveXs(theme.font.size.mobile.xlg, theme.font.size.xlg, theme.font.lineHeight.mobile.xlg);
  }

  return css(["", ";"], fontSize(theme.font.size.xlg));
}

export default StyledH2;